import React from 'react';
import PropTypes from 'prop-types';
import RequestSent from './RequestSent';
import Modal from './Modal';
import './ForgotPasswordModal.css';

export default function RequestSentModal(props) {
  const isCloseable = true;
  const onRequestClose = isCloseable ? props.onRequestClose : () => {};
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={onRequestClose}
      className="forgot-password-modal"
      showCloseButton={!props.isLoading}
    >
      <RequestSent {...props} />
    </Modal>
  );
}

RequestSentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  ...RequestSent.PropTypes
};



// WEBPACK FOOTER //
// ./src/components/RequestSentModal.js